import { render, staticRenderFns } from "./ModalLineMessage.vue?vue&type=template&id=12dd23aa&scoped=true&"
import script from "./ModalLineMessage.vue?vue&type=script&lang=ts&"
export * from "./ModalLineMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ModalLineMessage.vue?vue&type=style&index=0&id=12dd23aa&lang=scss&scoped=true&"
import style1 from "./ModalLineMessage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dd23aa",
  null
  
)

export default component.exports